import { CenteredSquaredContainer, FullscreenImageLayout } from 'ui-components';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  src: string;
}>;

export function ReferralLayout({ src, children }: Props): React.ReactElement {
  return (
    <FullscreenImageLayout src={src}>
      <CenteredSquaredContainer>{children}</CenteredSquaredContainer>
    </FullscreenImageLayout>
  );
}
